<template>
    <v-container fluid class="flex-column">
      <v-row>
        <img :src="require('@/assets/back/bg.png')"/>
      </v-row>
      <!-- 検索条件ダイアログ -->
      <v-dialog v-model="showConditionDialog" scrollable persistent>
        <v-container>
          <v-row justify="center">
            <v-col class="w-700-350 max-w-700-350 h-730-900">
              <v-card elevation="5" style="overflow-y: auto;">
                <!-- タブ名：簡単診断、詳細診断 -->
                <v-tabs v-model="tab" slider-color="transparent" class="h-80-60">
                  <v-tab value="simple" :class="{ 'active-tab': tab === 'simple', 'inactive-tab': tab !== 'simple' }"  class="md-h-min-80 sm-h-min-60">
                    <span class="font-22-18">簡単診断</span>
                  </v-tab>
                  <v-tab value="details" :class="{ 'active-tab': tab === 'details', 'inactive-tab': tab !== 'details' }" class="md-h-min-80 sm-h-min-60">
                    <div>
                        <p class="font-22-18">詳細診断</p>
                        <p class="font-16-12 details">※お手元に検針票がある方</p>
                    </div>
                  </v-tab>
                </v-tabs>
                <v-card-text class="dialog-card-text spacing-pa-inline-36-20 pa-0">
                  <v-tabs-window v-model="tab" class="pa-0 ma-0">
                    <!-------------------------------------------------- 
                        簡単診断
                    -------------------------------------------------->
                    <v-tabs-window-item value="simple" class="pa-0 ma-0">
                      <v-spacer class="spacing-h-30-12"/>
                        <!-------------------------------------------------- 
                            STEP1：世帯構成は？
                        -------------------------------------------------->
                        <!-- 質問文：世帯構成は？ -->
                        <v-row class="flex-start-y">
                          <div class="step-caption spacing-mr-12-12 font-17-15">STEP1</div>
                          <div class="font-21-16">世帯構成は？</div>
                        </v-row>
                        <v-spacer class="spacing-h-20-12"/>
                        <!-- 選択肢：1人、2人、3人、4人以上 -->
                        <v-row class="space-between">
                            <v-col md="3" cols="6" class="spacing-mb-0-8">
                                <v-btn class="w-140-140 h-70-50" :class="householdStructure === '1' ? 'selected-btn' : 'unselected-btn'" @click="householdStructure = '1'">1人</v-btn>
                            </v-col>
                            <v-col md="3" cols="6" class="spacing-mb-0-8">
                                <v-btn class="w-140-140 h-70-50" :class="householdStructure === '2' ? 'selected-btn' : 'unselected-btn'" @click="householdStructure = '2'">2人</v-btn>
                            </v-col>
                            <v-col md="3" cols="6">
                                <v-btn class="w-140-140 h-70-50" :class="householdStructure === '3' ? 'selected-btn' : 'unselected-btn'" @click="householdStructure = '3'">3人</v-btn>
                            </v-col>
                            <v-col md="3" cols="6">
                                <v-btn class="w-140-140 h-70-50" :class="householdStructure === '4' ? 'selected-btn' : 'unselected-btn'" @click="householdStructure = '4'">4人以上</v-btn>
                            </v-col>
                        </v-row>
                        <v-spacer class="spacing-h-32-24"/>
                        <!-------------------------------------------------- 
                            STEP2：電気を使う頻度や量はどれぐらいだと思いますか？
                        -------------------------------------------------->
                        <!-- 質問文：電気を使う頻度や量はどれぐらいだと思いますか？ -->
                        <v-row>
                          <div class="flex-start-y">
                            <div class="step-caption spacing-mr-12-12 font-17-15">STEP2</div>
                            <div class="font-21-16">電気を使う頻度や量は？</div>
                          </div>
                        </v-row>
                        <v-spacer class="spacing-h-20-12"/>
                        <!-- 選択肢：少ない方、普通くらい、多い方 -->
                        <v-row class="space-between">
                            <v-col md="4" cols="4" class="spacing-mb-0-8">
                                <v-btn class="w-200-90 h-70-50 ma-0" :class="electricUsageLevel === 'low' ? 'selected-btn' : 'unselected-btn'" @click="electricUsageLevel = 'low'">少ない</v-btn>
                            </v-col>
                            <v-col md="4" cols="4" class="spacing-mb-0-8">
                                <v-btn class="w-200-90 h-70-50 ma-0" :class="electricUsageLevel === 'normal' ? 'selected-btn' : 'unselected-btn'" @click="electricUsageLevel = 'normal'">普通</v-btn>
                            </v-col>
                            <v-col md="4" cols="4">
                                <v-btn class="w-200-90 h-70-50 ma-0" :class="electricUsageLevel === 'high' ? 'selected-btn' : 'unselected-btn'" @click="electricUsageLevel = 'high'">多い</v-btn>
                            </v-col>
                        </v-row>
                        <v-spacer class="spacing-h-32-24"/>
                        <!-------------------------------------------------- 
                            STEP3：オール電化にしていますか？
                        -------------------------------------------------->
                        <!-- 質問文：オール電化にしていますか？ -->
                        <v-row>
                          <div class="flex-start-y">
                            <div class="step-caption spacing-mr-12-12 font-17-15">STEP3</div>
                            <div class="font-21-16">オール電化にしていますか？</div>
                          </div>
                        </v-row>
                        <v-spacer class="spacing-h-20-12"/>
                        <!-- 選択肢：いいえ、オール電化住宅である -->
                        <v-row class="flex-start-x">
                            <v-col md="3" cols="5" class="spacing-mb-0-8">
                                <v-btn class="w-140-120 h-70-50" :class="allElectric === 'normal' ? 'selected-btn' : 'unselected-btn'" @click="allElectric = 'normal'">
                                    <span>いいえ</span>
                                </v-btn>
                            </v-col>
                            <v-col md="7" cols="7">
                                <v-btn class="w-240-180 h-70-50 flex-center" :class="allElectric === 'allElectric' ? 'selected-btn' : 'unselected-btn'" @click="allElectric = 'allElectric'">
                                    <span>オール電化住宅である</span>
                                </v-btn>
                            </v-col>
                            <v-spacer/>
                        </v-row>
                        <v-spacer class="spacing-h-16-4"/>
                        <!-- 注意書き -->
                        <v-row class="fong-14-10 red">
                            ※本サイトでは、オール電化専用プランは表示されません
                        </v-row>
                        <v-spacer class="spacing-h-32-24"/>
                        <!-- 診断結果を見るボタン -->
                        <v-row class="flex-center">
                            <v-btn class="search-button font-20-17 flex-center" elevation="0" :loading="isLoading" :disabled="isLoading" @click="searchCompany('simple')">
                              <v-icon left class="spacing-mr-20-20">mdi-checkbox-marked-outline</v-icon>
                              <span>診断結果を見る</span>
                            </v-btn>
                        </v-row>
                        <v-spacer class="spacing-h-32-24"/>
                    </v-tabs-window-item>
                    <!-------------------------------------------------- 
                        詳細診断
                    -------------------------------------------------->
                    <v-tabs-window-item value="details" class="pa-0 ma-0">
                      <v-spacer class="spacing-h-20-20" />
                      <v-row class="font-14-12 weight-normal">
                        東京電力EPの従量電灯Bで計算します。それ以外は自動計算に対応していないため、ご自身で電力使用量・電気代を入力してください
                      </v-row>
                      <v-spacer class="spacing-h-20-20" />
                      <!-------------------------------------------------- 
                          STEP1：現在のプランを選択してください
                      -------------------------------------------------->
                      <!-- 質問文：現在のプランを選択してください -->
                      <v-row class="flex-center-y">
                        <div class="flex-start-y">
                          <div class="step-caption spacing-mr-12-12 font-17-15">STEP1</div>
                          <div class="font-21-18">現在のプランを選択してください</div>
                        </div>
                      </v-row>
                      <v-spacer class="spacing-h-20-20"/>
                      <!-- 選択肢：電力会社、契約種別、アンペア数 -->
                      <v-row class="flex-column">
                        <div class="font-21-16">電力会社・契約種別（プラン）</div>
                        <v-spacer class="spacing-h-14-14"/>
                        <v-select
                            v-model="selectedCompany"
                            :items="companyOptions"
                            item-title="name"
                            item-value="value"
                            class="font-18-16 blue"
                            outlined
                            dense
                            hide-details
                        />
                      </v-row>
                      <v-spacer class="spacing-h-20-20"/>
                      <v-row class="flex-column">
                        <div class="font-21-16">契約容量（アンペア数）</div>
                        <v-spacer class="spacing-h-14-14"/>
                        <v-select
                            v-model="selectedAmps"
                            :items="availableAmps"
                            item-title="name"
                            item-value="value"
                            class="font-18-16 blue"
                            outlined
                            dense
                            hide-details
                        />
                      </v-row>
                      <v-spacer class="spacing-h-32-32" />
                      <!-------------------------------------------------- 
                          STEP2：月ごとの電力使用量と、電気料金合計金額(税込) を入力してください。
                      -------------------------------------------------->
                      <!-- 質問文：月ごとの電力使用量と、電気料金合計金額(税込) を入力してください。 -->
                      <v-row class="flex-center-y">
                        <div class="flex-start-y">
                          <div class="step-caption spacing-mr-12-12 font-17-15">STEP2</div>
                          <div class="font-21-18">月ごとの電力使用量と、電気料金合計金額(税込) を入力してください。</div>
                        </div>
                      </v-row>
                      <v-spacer class="spacing-h-20-20"/>
                      <!-- 月、電力使用量、電気代、計算ボタン -->
                      <v-row v-if="!shouldHideStep2" class="space-around">
                          <!-- 月 -->
                          <v-col md="3" cols="12" class="spacing-mb-0-16">
                              <v-select
                                  v-model="selectedMonth"
                                  :items="monthOptions"
                                  item-title="name"
                                  item-value="value"
                                  class="spacing-pr-12-12 font-18-16 blue"
                                  outlined
                                  denses
                                  hide-details
                                  />
                          </v-col>
                          <!-- 電力使用量 -->
                          <v-col md="3" cols="6" class="flex-end-x flex-center-y spacing-mb-0-16">
                              <input
                                  class="custom-input-usage font-30-25"
                                  type="text"
                                  v-model="monthlyUsage"
                                  inputmode="numeric"
                                  @input="onRestrictedMonthlyUsageInput"
                              />
                              <div class="spacing-pa-inline-12-12 font-18-16">kWh</div>
                          </v-col>
                          <!-- 電気代 -->
                          <v-col md="3" cols="6" class="flex-end-x flex-center-y spacing-mb-0-16">
                              <input
                                  class="custom-input-cost font-30-25"
                                  :class="{ 'input-disabled': selectedCompany === 'tepco' }"
                                  type="text"
                                  v-model="monthlyCost"
                                  inputmode="numeric"
                                  @input="onRestrictedMonthlyCostInput"
                                  :disabled="selectedCompany === 'tepco'"
                              />
                              <div class="spacing-pa-inline-12-12 font-18-16">円</div>
                          </v-col>
                          <!-- 計算ボタン -->
                          <v-col md="3" cols="12" class="flex-end-x flex-start-y spacing-mb-0-16">
                              <v-btn class="calculate-btn font-18-18" :disabled="!isCalculateEnabled" @click="calculateMonthlyCost('details')">
                                  計算する
                              </v-btn>
                          </v-col>
                          <v-spacer/>
                      </v-row>
                      <!-- 各月の電力使用量、電気代 -->
                      <v-row v-if="showZeroUsageError" class="mt-1">
                        <v-col cols="12" class="text-left red medium bold">
                            電力使用量は1kWh以上で入力してください
                        </v-col>
                      </v-row>
                      <v-spacer class="spacing-h-20-20"/>
                      <v-row class="space-between">
                          <!-- 1月～6月 -->
                          <v-col md="6" cols="12">
                            <!-- 月 + 電力使用量 + 電気代 -->
                            <v-row>
                              <v-col md="2" cols="2"></v-col>
                              <v-col md="5" cols="5" class="text-left">&emsp;電力使用量</v-col>
                              <v-col md="5" cols="5" class="text-left">&emsp;&emsp;電気料金</v-col>
                              <v-col md="2" cols="2"></v-col>
                            </v-row>
                            <v-row
                                v-for="(month, index) in months.slice(0, 6)"
                                :key="month.label"
                                class="flex-start-x "
                            >
                                <v-col md="2" cols="2" class="flex-center pa-1 md-16 sm-16">{{ month.label }}</v-col>
                                <v-col md="5" cols="5" class="flex-center pa-1">
                                    <input
                                        class="custom-input md-18 sm-18"
                                        type="text"
                                        v-model="months[index].usage"
                                        @input="onRestrictedUsageInput(index)"
                                        inputmode="numeric"
                                    />
                                    <div class="pl-2 small bold">kWh</div>
                                </v-col>
                                <v-col md="5" cols="5" class="flex-center pa-1">
                                    <input
                                    class="custom-input"
                                    :class="{ 'input-disabled': selectedCompany === 'tepco' }"
                                    type="text"
                                    v-model="months[index].cost"
                                    @input="onRestrictedCostInput(index)"
                                    inputmode="numeric"
                                    :disabled="selectedCompany === 'tepco'"
                                    />
                                    <div class="pl-2 small bold">円</div>
                                </v-col>
                            </v-row>
                          </v-col>
                          <!-- 7月～12月 -->
                          <v-col md="6" cols="12">
                            <!-- 月 + 電力使用量 + 電気代 -->
                            <v-row v-if="!isSm">
                              <v-col md="2" cols="2"></v-col>
                              <v-col md="5" cols="5" class="text-left">&emsp;電力使用量</v-col>
                              <v-col md="5" cols="5" class="text-left">&emsp;&emsp;電気料金</v-col>
                              <v-col md="2" cols="2"></v-col>
                            </v-row>
                            <v-row
                                v-for="(month, index) in months.slice(6, 12)"
                                :key="month.label"
                                class="flex-start-x small bold"
                            >
                                <v-col md="2" cols="2" class="flex-center pa-1 md-16 sm-16">{{ month.label }}</v-col>
                                <v-col md="5" cols="5" class="flex-center pa-1">
                                    <input
                                        class="custom-input md-18 sm-18"
                                        type="text"
                                        v-model="months[index + 6].usage"
                                        @input="onRestrictedUsageInput(index + 6)"
                                        inputmode="numeric"
                                    />
                                    <div class="pl-2 small bold">kWh</div>
                                </v-col>
                                <v-col md="5" cols="5" class="flex-center pa-1">
                                    <input
                                    class="custom-input"
                                    :class="{ 'input-disabled': selectedCompany === 'tepco' }"
                                    type="text"
                                    v-model="months[index + 6].cost"
                                    @input="onRestrictedCostInput(index + 6)"
                                    inputmode="numeric"
                                    :disabled="selectedCompany === 'tepco'"
                                    />
                                    <div class="pl-2 small bold">円</div>
                                </v-col>
                            </v-row>
                          </v-col>
                      </v-row>
                      <v-spacer class="spacing-h-20-20"/>
                      <!-- 注意書き -->
                      <v-row class="fong-14-10 red">
                          ※本サイトでは、オール電化専用プランは表示されません
                      </v-row>
                      <v-spacer class="spacing-h-36-24"/>
                      <!-- 診断結果を見るボタン -->
                      <v-row class="flex-center">
                          <v-btn class="search-button font-20-17 flex-center" elevation="0" :loading="isLoading" :disabled="isLoading" @click="searchCompany('details')">
                            <v-icon left class="spacing-mr-20-20">mdi-checkbox-marked-outline</v-icon>
                            <span>診断結果を見る</span>
                          </v-btn>
                      </v-row>
                      <v-spacer class="spacing-h-32-24" />
                    </v-tabs-window-item>
                  </v-tabs-window>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
    </v-container>
</template>


<script setup>
import { ref, onMounted, computed, reactive, watch, unref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import './main.css';
import { useDisplay } from 'vuetify'
const router = useRouter();
const route = useRoute();
const display = useDisplay()
const isSmDispLay = computed(() => display.smAndDown)
const isSm = unref(isSmDispLay)

// 初期処理
onMounted(() => {
  if (route.query.showDialog === 'true') {
    showConditionDialog.value = true;
  }
  try {
    // 電力使用量初期値セット
    updateUsage()
  } catch (e) {
    console.error('初期値失敗:', e)
    router.push({ name: 'TopPage' });
  } 
});

// 検索ダイアログ表示
const showConditionDialog = ref(false);

// 検索ダイアログ（simple：簡単診断、details：詳細診断）
const tab = ref('simple');

/*******************************
 * 簡単診断 検索条件
*******************************/
// 世帯構成
var householdStructure = ref('3');
// 電気を使う頻度や量は多い方だと思いますか？
var electricUsageLevel = ref('normal');
// オール電化住宅か
var allElectric = ref('normal');
const usageTable = {
  '1': [270, 253, 225, 182, 176, 164, 200, 237, 191, 171, 174, 207],
  '2': [417, 396, 354, 277, 253, 231, 282, 349, 278, 244, 254, 316],
  '3': [475, 450, 412, 328, 298, 267, 329, 409, 327, 285, 292, 370],
  '4': [507, 472, 431, 344, 316, 292, 362, 450, 354, 309, 322, 389],
};
// STEP2：電気を使う頻度や量は多い方だと思いますか？（normal: 普通くらい、high: 多い方、low: 少ない方）
const electricUsageFactorMap = {
  normal: 1.0,
  high: 1.35,
  low: 0.65
}

// STEP3：オール電化か？（normal: allElectric: オール電化住宅である）
const allElectricFactorMap = {
  normal: 1.0,
  allElectric: 1.5
}

// 電力使用量12ヶ月分
const simpleUsage = ref(new Array(12).fill(0))

// 使用量の更新処理（世帯構成・係数を反映）
const updateUsage = () => {
  const baseList = usageTable[householdStructure.value]
  const usageFactor = electricUsageFactorMap[electricUsageLevel.value]
  const electricFactor = allElectricFactorMap[allElectric.value]
  const totalFactor = usageFactor * electricFactor

  for (let i = 0; i < 12; i++) {
    simpleUsage.value[i] = Math.round(baseList[i] * totalFactor)
  }
}

//  イベントトリガー: 選択肢変更時に再計算
watch([householdStructure, electricUsageLevel, allElectric], () => {
  updateUsage()
})

/*******************************
 * 詳細診断 検索条件
 *******************************/
// 初期値：電力会社、契約種別、アンペア数
const selectedCompany = ref('tepco')
const selectedAmps = ref(40)
const selectedPlan = ref('planB')

// --- STEP1 : 世帯構成は？ ---
// プルダウン選択肢：電力会社、契約種別、アンペア数
const companyOptions = [
  {
    name: '東京電力EP・従量電灯B',
    value: 'tepco',
    amps: [
      { name: '20A', value: 20 },
      { name: '30A', value: 30 },
      { name: '40A', value: 40 },
      { name: '50A', value: 50 },
      { name: '60A', value: 60 }
    ]
  },
  {
    name: 'その他',
    value: 'other',
    amps: [
      { name: '20A', value: 20 },
      { name: '30A', value: 30 },
      { name: '40A', value: 40 },
      { name: '50A', value: 50 },
      { name: '60A', value: 60 }
    ]
  }
]

const availableAmps = computed(() => {
  const option = companyOptions.find(c => c.value === selectedCompany.value)
  return option?.amps || []
})

watch(selectedCompany, (newCompany) => {
  const option = companyOptions.find(c => c.value === newCompany)
  selectedAmps.value = option?.amps?.[2]?.value || 40  // ← .value を明示
})


watch(selectedCompany, (newVal) => {
  if (newVal === 'other') {
    selectedPlan.value = 'other'
  }
})


// --- STEP2 : 月間電力使用量と電気代を入力してください ---
// 選択月（1月～12月）
// 現在の月を取得（1〜12の文字列に変換）
var currentMonth = new Date().getMonth();
const selectedMonth = ref(currentMonth);
const monthOptions = [
  { name: '1月', value: 1 },
  { name: '2月', value: 2 },
  { name: '3月', value: 3 },
  { name: '4月', value: 4 },
  { name: '5月', value: 5 },
  { name: '6月', value: 6 },
  { name: '7月', value: 7 },
  { name: '8月', value: 8 },
  { name: '9月', value: 9 },
  { name: '10月', value: 10 },
  { name: '11月', value: 11 },
  { name: '12月', value: 12 }
];

// ひと月当たりの電力使用量
const monthlyUsage = ref(0);

// ひと月当たりの電気料金
const monthlyCost = ref(0);

// 電力会社・契約種別・アンペア数がどれか1つでもその他の場合
// ひと月当たりの電力使用量・電気料金は非表示
const shouldHideStep2 = computed(() => {
  return (
    selectedCompany.value === 'other'
  )
})

// 各月の電力使用量、電気料金
const months = reactive([
  { label: '1月', usage: 0, cost: 0 },
  { label: '2月', usage: 0, cost: 0 },
  { label: '3月', usage: 0, cost: 0 },
  { label: '4月', usage: 0, cost: 0 },
  { label: '5月', usage: 0, cost: 0 },
  { label: '6月', usage: 0, cost: 0 },
  { label: '7月', usage: 0, cost: 0 },
  { label: '8月', usage: 0, cost: 0 },
  { label: '9月', usage: 0, cost: 0 },
  { label: '10月', usage: 0, cost: 0 },
  { label: '11月', usage: 0, cost: 0 },
  { label: '12月', usage: 0, cost: 0 },
])

// 電力使用量を1以上で入力したら計算するボタンを活性
const isCalculateEnabled = computed(() => {
  const value = Number(monthlyUsage.value)
  return !isNaN(value) && value >= 1
})

// 電力使用量が0の場合はエラー
const showZeroUsageError = ref(false)
function hasZeroUsageValue() {
  return months.some(m => Number(m.usage) === 0)
}

// (watch)電力使用量を1以上で入力されていたらエラーメッセージ解除
watch(
  () => months.map(m => Number(m.usage)),
  (newUsages) => {
    if (showZeroUsageError.value && newUsages.every(u => u >= 1)) {
      showZeroUsageError.value = false
    }
  },
  { deep: true }
)


// ひと月当たり電力使用量 入力制御(0~999kWh)
function onRestrictedMonthlyUsageInput(event) {
  const input = event.target.value.replace(/[^0-9]/g, ''); // 数字以外削除
  const value = Number(input);

  if (value > 999) {
    monthlyUsage.value = '999';
  } else if (value < 0) {
    monthlyUsage.value = '0';
  } else {
    monthlyUsage.value = input;
  }
}

// ひと月当たり電気料金 入力制御(0~9999円)
function onRestrictedMonthlyCostInput(event) {
  const input = event.target.value.replace(/[^0-9]/g, ''); // 数字以外削除
  const value = Number(input);

  if (value > 99999) {
    monthlyCost.value = '99999';
  } else if (value < 0) {
    monthlyCost.value = '0';
  } else {
    monthlyCost.value = input;
  }
}

// 1~12月 電力使用量 入力制御(0~999kWh)
function onRestrictedUsageInput(index) {
  let raw = String(months[index].usage).replace(/[^0-9]/g, '');
  let value = Number(raw);

  if (value > 999) value = 999;
  if (value < 0 || isNaN(value)) value = 0;

  months[index].usage = value;
}

// 1~12月 電気料金 入力制御(0~9999円)
function onRestrictedCostInput(index) {
  let raw = String(months[index].cost).replace(/[^0-9]/g, '');
  let value = Number(raw);

  if (value > 99999) value = 99999;
  if (value < 0 || isNaN(value)) value = 0;

  months[index].cost = value;
}


/************************************************************
 * 月ごとの電力使用量を計算
 * API: CalculateMonthlyCost
 ************************************************************/
async function calculateMonthlyCost(searchType) {
    var baseMonth = new Date().getMonth();
    var baseUsage = 0;
    var requestData = {};
    
    // --- 簡単診断の場合、 ---
    if (searchType === 'simple') {
        requestData = {
            amps: 40, // 40A固定
            usageM01: simpleUsage.value[0],
            usageM02: simpleUsage.value[1],
            usageM03: simpleUsage.value[2],
            usageM04: simpleUsage.value[3],
            usageM05: simpleUsage.value[4],
            usageM06: simpleUsage.value[5],
            usageM07: simpleUsage.value[6],
            usageM08: simpleUsage.value[7],
            usageM09: simpleUsage.value[8],
            usageM10: simpleUsage.value[9],
            usageM11: simpleUsage.value[10],
            usageM12: simpleUsage.value[11],
        };
    } else {
        baseMonth = Number(selectedMonth.value);
        baseUsage = monthlyUsage.value;
        // 月ごとの使用量を推計するための係数
        const coefficients = [1.000, 0.949, 0.808, 0.773, 0.626, 0.540, 0.646, 0.758, 0.732, 0.626, 0.601, 0.722];

        // 基準月の係数（index は baseMonth - 1）
        const baseCoefficient = coefficients[baseMonth - 1];

        for (let i = 0; i < 12; i++) {
            const ratio = coefficients[i] / baseCoefficient;
            months[i].usage = Math.round(baseUsage * ratio);
        }
        requestData = {
            amps: selectedAmps.value,
            usageM01: months[0].usage,
            usageM02: months[1].usage,
            usageM03: months[2].usage,
            usageM04: months[3].usage,
            usageM05: months[4].usage,
            usageM06: months[5].usage,
            usageM07: months[6].usage,
            usageM08: months[7].usage,
            usageM09: months[8].usage,
            usageM10: months[9].usage,
            usageM11: months[10].usage,
            usageM12: months[11].usage,
        };
    }

    try {
      // const response = await fetch('https://simulation-uchikara-setagaya-api-djd6f4d7h4fuhkg6.eastasia-01.azurewebsites.net/api/CalculateMonthlyCost', {
      // const response = await fetch('https://dev-simulation-uchikara-setagaya-geaefad9gpgphsaf.eastasia-01.azurewebsites.net/api/CalculateMonthlyCost', {
      const response = await fetch('https://simulation-uchikara-setagaya-api-djd6f4d7h4fuhkg6.eastasia-01.azurewebsites.net/api/CalculateMonthlyCost', {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData),
        });

        if (!response.ok) throw new Error('API呼び出しに失敗しました');

        const responseData = await response.json();

        if (responseData.status === 'success') {
            const data = responseData.dataList[0];
            if (searchType === 'details') {
                months[0].cost = data.costM01;
                months[1].cost= data.costM02;
                months[2].cost= data.costM03;
                months[3].cost= data.costM04;
                months[4].cost= data.costM05;
                months[5].cost= data.costM06;
                months[6].cost= data.costM07;
                months[7].cost= data.costM08;
                months[8].cost= data.costM09;
                months[9].cost= data.costM10;
                months[10].cost= data.costM11;
                months[11].cost= data.costM12;

                const costKey = `costM${(selectedMonth.value).toString().padStart(2, '0')}`; // 'costM01' など

                if (data[costKey] !== undefined) {
                    monthlyCost.value = data[costKey];
                }
            }
        } else {
        throw new Error(responseData.message || '不明なエラーが発生しました');
        }
    } catch (error) {
        console.error('エラーが発生しました:', error);
        router.push({ name: 'TopPage' });
    }
}

/*******************************
 * レスポンス
 *******************************/
const transactionId = ref('');
const searchType = ref('');
const currentBaseCost = ref(0);
const currentUsageCost = ref(0);
const currentFuelAdjustmentCost = ref(0);
const currentPowerProcurementCost = ref(0);
const currentCapacityContributionCost = ref(0);
const currentRenewableSurchargeCost = ref(0);
const currentAnnualCost = ref(0);
const currentMonthlyCost = ref(0);
const annualUsage = ref(0);
const plasticBottle = ref(0);
const gasolene = ref(0);
const tree = ref(0);
const isLoading = ref(false);
const companies = ref([]);

async function searchCompany(selectedSearchType) {
  showZeroUsageError.value = false;

  // 🔍 入力チェック（API実行前に return）
  if (selectedSearchType === 'details' && hasZeroUsageValue()) {
    showZeroUsageError.value = true;
    return;
  }

  isLoading.value = true;
  try {
    var requestData = {};

    // 簡単診断の場合は電力使用量、電気料金を推計
    if (selectedSearchType === 'simple') {
        await calculateMonthlyCost(selectedSearchType);
        annualUsage.value = simpleUsage.value.reduce((a, b) => a + b, 0)
        requestData = {
            searchType: selectedSearchType,
            householdStructure: householdStructure.value,
            electricUsageLevel: electricUsageLevel.value,
            allElectric: allElectric.value,
            company: selectedCompany.value,
            plan: selectedPlan.value,
            amps: selectedAmps.value,
            month: selectedMonth.value,
            monthlyUsage: monthlyUsage.value,
            monthlyCost: monthlyCost.value,
            usageM01: simpleUsage.value[0],
            usageM02: simpleUsage.value[1],
            usageM03: simpleUsage.value[2],
            usageM04: simpleUsage.value[3],
            usageM05: simpleUsage.value[4],
            usageM06: simpleUsage.value[5],
            usageM07: simpleUsage.value[6],
            usageM08: simpleUsage.value[7],
            usageM09: simpleUsage.value[8],
            usageM10: simpleUsage.value[9],
            usageM11: simpleUsage.value[10],
            usageM12: simpleUsage.value[11],
            costM01: 0,
            costM02: 0,
            costM03: 0,
            costM04: 0,
            costM05: 0,
            costM06: 0,
            costM07: 0,
            costM08: 0,
            costM09: 0,
            costM10: 0,
            costM11: 0,
            costM12: 0,
            annualUsage: annualUsage.value
        };
    } else {
        annualUsage.value = months.reduce((sum, month) => sum + Number(month.usage || 0), 0)
        requestData = {
            searchType: selectedSearchType,
            householdStructure: householdStructure.value,
            electricUsageLevel: electricUsageLevel.value,
            allElectric: allElectric.value,
            company: selectedCompany.value,
            plan: selectedPlan.value,
            amps: selectedAmps.value,
            month: selectedMonth.value,
            monthlyUsage: monthlyUsage.value,
            monthlyCost: monthlyCost.value,
            usageM01: months[0].usage,
            usageM02: months[1].usage,
            usageM03: months[2].usage,
            usageM04: months[3].usage,
            usageM05: months[4].usage,
            usageM06: months[5].usage,
            usageM07: months[6].usage,
            usageM08: months[7].usage,
            usageM09: months[8].usage,
            usageM10: months[9].usage,
            usageM11: months[10].usage,
            usageM12: months[11].usage,
            costM01: months[0].cost,
            costM02: months[1].cost,
            costM03: months[2].cost,
            costM04: months[3].cost,
            costM05: months[4].cost,
            costM06: months[5].cost,
            costM07: months[6].cost,
            costM08: months[7].cost,
            costM09: months[8].cost,
            costM10: months[9].cost,
            costM11: months[10].cost,
            costM12: months[11].cost,
            annualUsage: annualUsage.value
        };
    }

    // const response = await fetch('https://simulation-uchikara-setagaya-api-djd6f4d7h4fuhkg6.eastasia-01.azurewebsites.net/api/SearchCompany', {
    // const response = await fetch('https://dev-simulation-uchikara-setagaya-geaefad9gpgphsaf.eastasia-01.azurewebsites.net/api/SearchCompany', {
    const response = await fetch('https://simulation-uchikara-setagaya-api-djd6f4d7h4fuhkg6.eastasia-01.azurewebsites.net/api/SearchCompany', {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error('API呼び出しに失敗しました');

    const responseData = await response.json();
    if (responseData.status === 'success') {
      const data = responseData.dataList[0];
      transactionId.value = data.transactionId;
      searchType.value = data.searchType;
      plasticBottle.value = data.plasticBottle;
      gasolene.value = data.gasolene;
      tree.value = data.tree;
      currentBaseCost.value = data.currentBaseCost;
      currentUsageCost.value = data.currentUsageCost;
      currentFuelAdjustmentCost.value = data.currentFuelAdjustmentCost;
      currentPowerProcurementCost.value = data.currentPowerProcurementCost;
      currentCapacityContributionCost.value = data.currentCapacityContributionCost;
      currentRenewableSurchargeCost.value = data.currentRenewableSurchargeCost;
      currentAnnualCost.value = data.currentAnnualCost;
      currentMonthlyCost.value = data.currentMonthlyCost;
      companies.value = data.companies;
    } else {
      throw new Error(responseData.message || '不明なエラーが発生しました');
    }
  } catch (error) {
    console.error('APIエラー:', error);
    router.push({ name: 'TopPage' });
  }

  const resultData = {
    transactionId: transactionId.value,
    searchType: searchType.value,
    plasticBottle: plasticBottle.value,
    gasolene: gasolene.value,
    tree: tree.value,
    currentBaseCost: currentBaseCost.value,
    currentUsageCost: currentUsageCost.value,
    currentFuelAdjustmentCost: currentFuelAdjustmentCost.value,
    currentPowerProcurementCost: currentPowerProcurementCost.value,
    currentCapacityContributionCost: currentCapacityContributionCost.value,
    currentRenewableSurchargeCost: currentRenewableSurchargeCost.value,
    currentAnnualCost: currentAnnualCost.value,
    currentMonthlyCost: currentMonthlyCost.value,
    annualUsage: annualUsage.value,
    companies: companies.value,
  };

  isLoading.value = false;

localStorage.setItem('searchResult', JSON.stringify(resultData));
  router.push({ name: 'SearchResult' });
}
</script>
